import { render, staticRenderFns } from "./CkEditorText.vue?vue&type=template&id=0a9b6589&scoped=true&"
import script from "./CkEditorText.vue?vue&type=script&lang=js&"
export * from "./CkEditorText.vue?vue&type=script&lang=js&"
import style0 from "./CkEditorText.vue?vue&type=style&index=0&id=0a9b6589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b6589",
  null
  
)

export default component.exports